/*
 * サブシステム名：マスタ管理
 * 機能名：取引先グループマスタ一覧
 */
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdCustomButton from '@/components/DdCustomButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'

// import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdCodeTextBox = () => import('../../../components/DdCodeTextBox.vue')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstTorihikisakiList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdSpreadSheet,
    DdCodeTextBox,
    DdDataTable,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      torihikisakiCd: '',
      torihikisakiKbn: '0',
      tokuisakiFlg: true,
      shiiresakiFlg: true,
      hacchusakiFlg: true,
      torihikisakiNm: '',
      torihikisakiNmKana: '',
      shanaiTantoshaCd: '',
      torihikisakiBunruiKbn1: null,
      torihikisakiBunruiKbn2: null,
      torihikisakiBunruiKbn3: null
    },
    headersShanaishuTantoshaList: header.mstJininHeaders,
    modeKengen: 0,
    page: 1,
    isSearched: false,
    /*
    headersShanaishuTantoshaList: [
      { width: '60px', text: '社内主担当者コード', value: 'jininCd' },
      { width: '90px', text: '社内主担当者名', value: 'jininNm' }
    ]
    */
    // スプレッドシートオプション
    option: {
      // // テーブル最大高さ
      tableHeight: null,
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        noRecordsFound: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む'
      }
    }
  }),
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        elem.memo = elem.editFlg === true ? '変更中' : '　　　'
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      jininList: 'DDMasters/mstJinin',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredShanaishuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    torihikisakiBunruiKbn1List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT002')
    },
    torihikisakiBunruiKbn2List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT003')
    },
    torihikisakiBunruiKbn3List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT004')
    },

    // スプレッドシートヘッダー
    SpreadHeader () {
      const target = filter.dateFormatter(new Date())

      var wkTokuisakiList = ['未選択']
      const mTokuisakiList = this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
      const tTokuisakiList = mTokuisakiList.map(elem => {
        return elem.torihikisakiCd + ' : ' + elem.torihikisakiNm
      })
      wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)
      // ヘッダー定義
      return [
        { title: '', name: 'id', type: 'hidden' },
        { title: '', name: 'rowNo', type: 'hidden' },
        { title: '', name: 'editFlg', type: 'hidden' },
        { title: '変更', name: 'memo', type: 'text', customInput: null, readOnly: true, width: '35px' },
        { title: '削除', name: 'delFlg', type: 'checkbox', customInput: null, width: '35px' },
        { title: '取引先コード（親）', name: 'parentTorihikisakiCdNm', type: 'dropdown', customInput: null, source: wkTokuisakiList, width: '400px', autocomplete: true },
        { title: '', name: 'd1', type: 'text', customInput: null, readOnly: true, width: '0px' },
        { title: '取引先コード（子）', name: 'childTorihikisakiCdNm', type: 'dropdown', customInput: null, source: wkTokuisakiList, width: '400px', autocomplete: true },
        { title: '表示順', name: 'hyojiOrder', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, readOnly: true, width: '100px' }
      ]
    },
    computedColNumList () {
      var result = {}
      this.SpreadHeader.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },

    // 保存ボタン活性条件
    isMultiSaveButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              parentTorihikisakiCd: '',
              parentTorihikisakiNm: '',
              childTorihikisakiCd: '',
              childTorihikisakiNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstTorihikisakiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTorihikisakiList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTorihikisakiList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTorihikisakiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstTorihikisakiGroup/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload

          // スプレッドシート用編集
          resultData.map((elem, index) => {
            elem.rowNo = index + 1
            elem.editFlg = false
            elem.editMode = false
            elem.parentTorihikisakiCdNm = elem.parentTorihikisakiCd + ' : ' + elem.parentTorihikisakiNm
            elem.childTorihikisakiCdNm = elem.childTorihikisakiCd + ' : ' + elem.childTorihikisakiNm
            return elem
          })
          self.rows = resultData
          self.isSearched = true

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            torihikisakiKbn: self.conditions.torihikisakiKbn
          }
        }
      }
      this.search(opt)
    },

    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              parentTorihikisakiCd: '',
              parentTorihikisakiNm: '',
              childTorihikisakiCd: '',
              childTorihikisakiNm: ''
            }
            self.searchText = ''
            self.rows = []
            self.isSearched = false
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    searchValidate: function () {
      return true
    },

    onMultiSaveButtonClick: function (e) {
      const self = this

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && ![undefined, null, ''].includes(elem.parentTorihikisakiCdNm) && ![undefined, null, ''].includes(elem.childTorihikisakiCdNm)
      })
      if (saveTargetRow.length < 1) { return }

      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? 0 : elem.id
        // 数値変換
        elem.hyojiOrder = elem.hyojiOrder ? self.getNullValue(elem.hyojiOrder) : null
        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      const target = filter.dateFormatter(new Date())
      const mTokuisakiList = this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })

      saveTargetRow.map((elem) => {
        elem.parentTorihikisakiId = 0
        elem.childTorihikisakiId = 0

        // 取引先コード（親）
        const parentCd = elem.parentTorihikisakiCdNm.split(' : ')
        const parent = mTokuisakiList.filter(function (item) {
          return item.torihikisakiCd === parentCd[0]
        })
        if (parent.length > 0) {
          elem.parentTorihikisakiId = parent[0].id
        }
        // 取引先コード（子）
        const childCd = elem.childTorihikisakiCdNm.split(' : ')
        const child = mTokuisakiList.filter(function (item) {
          return item.torihikisakiCd === childCd[0]
        })
        if (child.length > 0) {
          elem.childTorihikisakiId = child[0].id
        }
        return elem
      })

      // 変換後チェック
      var failedConvertCnt = 0
      saveTargetRow.forEach((item) => {
        if (item.parentTorihikisakiId === 0 || item.childTorihikisakiId === 0) failedConvertCnt++
      })
      if (failedConvertCnt > 0) {
        modals.showError('取引先コードに不備があります。確認してください。')
      }
      this.$nextTick(function () {
        self.saveAction(saveTargetRow)
      })
    },
    saveAction: function (p) {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.put('/api/v1/VwCMstTorihikisakiGroup/Register', p)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            self.$nextTick(function () {
              self.onSearchButtonClick()
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return '0' }
      if (inputValue === undefined) { return '0' }
      if (inputValue === '') { return '0' }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return '0' }

      if (window.isFinite(num) === true) {
        return num.toString()
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },

    // スプレッドシート操作
    rowAppend: function (num) {
      for (let i = 0; i < num; i++) {
        const newrow = {
          id: 0,
          editFlg: false,
          editMode: false,
          rowNo: this.rows.length + 1,
          parentTorihikisakiCdNm: '未選択',
          childTorihikisakiCdNm: '未選択',
          hyojiOrder: '9999'
        }
        this.rows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    // スプレッドシート
    onChangeSpreadSheet: function (el, cell, x, y, value, oldValue, rowId) {
      // console.log('onChangeSpreadSheet', el, cell, x, y, value, oldValue, rowId)
      // 対象項目列の全ての値を取得
      const targetIndex = this.rows.findIndex((item) => item.rowNo === rowId)
      if (targetIndex >= 0) {
        // this.rows[targetIndex].memo = '*'
        // this.rows[targetIndex].editFlg = true
        const modifyMark = this.rows[targetIndex].delFlg ? '－' : this.rows[targetIndex].id > 0 ? '＊' : '＋'
        this.$refs.ddSpreadSheet.setValueFromCoords(this.computedColNumList.memo, y, modifyMark, true)
        this.$refs.ddSpreadSheet.setValueFromCoords(this.computedColNumList.editFlg, y, true, true)
      }
    }
  }
}
